import 'style/index.css';
import { StrictMode } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import routes from 'app/routes';
import { Provider } from 'react-redux';
import { store } from 'app/store';
import { ToastProvider } from 'app/components/atoms/toast/toast';
import { BarcodeScannerProvider } from 'app/context/BarcodeScannerContext';

const router = createBrowserRouter(routes);

function App() {
  return (
    <StrictMode>
      <Provider store={store}>
        <ToastProvider>
          <BarcodeScannerProvider>
            <RouterProvider router={router} />
          </BarcodeScannerProvider>
        </ToastProvider>
      </Provider>
    </StrictMode>
  );
}

export default App;
